import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Madres primerizas viviendo en USA que no tienen red de apoyo familiar cerca.', 'Mujeres que deben volver al trabajo pronto y necesitan rendir durante el día.', 'Madres que NO quieren usar métodos de llanto prolongado pero necesitan una solución técnica real.', 'Padres que quieren participar en la rutina de sueño de forma efectiva.'];
  const isNotFor = ["Personas que buscan resultados milagrosos de 'una sola noche' sin aplicar los pasos ambientales.", "Padres que prefieren el método tradicional de 'Cry-It-Out' (dejarlo llorar).", 'Familias que no están dispuestas a ajustar el entorno de la habitación del bebé.'];
  return <section className="bg-navy-light py-24 px-6" data-id="element-13">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-14">
        {/* Who this is for */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-cream rounded-2xl p-8 md:p-10 shadow-lg" data-id="element-15">
          <h3 className="text-2xl font-serif font-bold text-navy mb-8 flex items-center gap-3" data-id="element-16">
            <span className="bg-green-100 text-green-700 p-2 rounded-full" data-id="element-17">
              <CheckCircle2 className="w-6 h-6" data-id="element-18" />
            </span>
            Para quién es esto
          </h3>
          <ul className="space-y-6" data-id="element-19">
            {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-20">
                <CheckCircle2 className="w-6 h-6 text-green-600 shrink-0 mt-0.5" data-id="element-21" />
                <span className="text-navy/80 font-medium" data-id="element-22">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Who this is not for */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy rounded-2xl p-8 md:p-10 shadow-lg border border-navy-light" data-id="element-23">
          <h3 className="text-2xl font-serif font-bold text-cream mb-8 flex items-center gap-3" data-id="element-24">
            <span className="bg-red-900/50 text-red-400 p-2 rounded-full" data-id="element-25">
              <XCircle className="w-6 h-6" data-id="element-26" />
            </span>
            Para quién NO es
          </h3>
          <ul className="space-y-6" data-id="element-27">
            {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-28">
                <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-29" />
                <span className="text-cream/80" data-id="element-30">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}